// @flow
import React from 'react';
import _ from 'lodash/fp';
import './OrderCustomProductList.css';

export type Props = {
  products: any[],
};

const OrderCustomProductList = ({
  products,
}: Props) => (
  <div className="OrderCustomProductList">
    <div className="row">
      <div className="column">
        <table className="table">
          <thead>
            <tr>
              <th>Namn</th>
              <th>Leverantör</th>
              <th>Ext. artikelnr.</th>
              <th>Antal</th>
            </tr>
          </thead>
          <tbody>
            {_.map(row => (
              <tr
                key={row.id}
                className="OrderCustomProductList-product-row">
                <td className="ProductRowList-name">
                  {row.name}
                </td>
                <td className="OrderCustomProductList-supplier">
                  {_.get('supplier.name', row)}
                </td>
                <td>
                  {row.externalItemNumber}
                </td>
                <td>{row.quantity}</td>
              </tr>
            ), products)}
          </tbody>
        </table>
        {!products.length &&
          <div className="callout secondary">
            Inga friprodukter
          </div>
        }
      </div>
    </div>
  </div>
);

export default OrderCustomProductList;



// WEBPACK FOOTER //
// ./src/components/OrderCustomProductList/OrderCustomProductList.js